import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { formatMetodoPago, formatSplitValue } from "src/shared/helpers/formatMetodoPago"
import { ArticulosVendidosDetailProps } from "./ArticulosVendidosDetail.type"
import "./ArticulosVendidosDetail.css"

const emptyValue = "-"

const ArticulosVendidosDetail = ({ isOpen, onClose, data }: ArticulosVendidosDetailProps): JSX.Element => {
    // la fecha del reporte ya llega formateada desde el endpoint, se muestra igual que en la tabla
    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="articulos-vendidos-detail">
            <div className="art-detail__head">
                <p className="art-detail__title">Artículo vendido</p>
                <p className="art-detail__subtitle">{data?.Ticket || emptyValue}</p>
            </div>
            <div className="art-detail__body">
                <div className="art-detail__description">
                    <DescriptionDetail icon={"calendarFill"} label={"Fecha"} value={data?.Fecha || emptyValue} />
                    <DescriptionDetail icon={"FileListFill"} label={"Turno"} value={data?.Turno || emptyValue} />
                    <DescriptionDetail
                        className={"art-detail__value--multiline"}
                        icon={"building4Fill"}
                        label={"Origen"}
                        value={data?.Origen || "-"}
                    />
                    <DescriptionDetail
                        className={"art-detail__value--full"}
                        icon={"userFilled"}
                        label={"Responsable"}
                        value={data?.Responsable || emptyValue}
                    />
                    <DescriptionDetail
                        className={"art-detail__value--full"}
                        icon={"packageFill"}
                        label={"Artículo"}
                        value={data?.Articulo || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"FolderOpenFilled"}
                        label={"Categoría"}
                        value={data?.Categoria || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"CoinsFill"}
                        label={"Precio"}
                        value={formatCurrencyToFixed(Number(data?.Precio || 0))}
                    />
                    <DescriptionDetail
                        icon={"HashWhite"}
                        label={"Cantidad"}
                        value={data?.Cantidad !== undefined && data?.Cantidad !== null ? String(data.Cantidad) : emptyValue}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Total"}
                        value={formatCurrencyToFixed(Number(data?.Total || 0))}
                    />
                    <DescriptionDetail
                        icon={"priceTag"}
                        label={"Tipo de venta"}
                        value={data?.TipoVenta || emptyValue}
                    />
                    <DescriptionDetail
                        className={"art-detail__value--full"}
                        icon={"creditCard"}
                        label={"Método de pago"}
                        value={formatSplitValue(data?.MetodoPago, formatMetodoPago)}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default ArticulosVendidosDetail
